import {cloneDeep, find, forOwn} from 'lodash';

const FILTER_ID = 'id';
const FILTER_VALUE = 'value';
const FILTER_NAME = 'name';
const FILTER_TYPE = 'type';
const FILTER_DEFAULT = 'default';

export class UserFilter {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  clone() {
    return Object.assign(new UserFilter(cloneDeep(this.rawData)), this);
  }

  getId() {
    return this.rawData[FILTER_ID];
  }

  getName() {
    return this.rawData[FILTER_NAME];
  }

  getValue() {
    return this.rawData[FILTER_VALUE];
  }

  getType() {
    return this.rawData[FILTER_TYPE];
  }

  isDefault() {
    return this.rawData[FILTER_DEFAULT];
  }
}

export class UserFilters {
  static initFilters(rawFilters) {
    const filters = [];
    forOwn(rawFilters, (filter) => {
      filters.push(new UserFilter(filter));
    });
    return filters;
  }

  static normalizeType(type = '') {
    const normalizedType = type
      .replace(/\//g, '_')
      .replace(/&/g, '_')
      .replace(/\?/g, '_');
    return encodeURIComponent(normalizedType);
  }

  constructor(rawData = []) {
    this.rawData = [...rawData];
    this.filters = [];
    if (this.rawData) {
      this.filters = UserFilters.initFilters(this.rawData);
    }
  }

  clone() {
    return Object.assign(new UserFilters(cloneDeep(this.rawData)), this);
  }

  getFilters() {
    return this.filters;
  }

  getFilter(id) {
    return find(this.filters, (filter) => filter.getId() === id);
  }

  getFilterByName(name) {
    return find(this.filters, (filter) => filter.getName() === name);
  }

  getDefaultFilter() {
    return find(this.filters, (filter) => filter.isDefault());
  }
}

export default {UserFilters, UserFilter};
